import React, { useState, useEffect } from "react";
import "./landiningnavbar.css";
import iiaLogo from "../../img/aaaservices/LogoIIAHead.png";

const NAV_LINKS = [
    { label: "Home", href: "#home" },
    { label: "About", href: "#about" },
    { label: "Corporate", href: "#corporate" },
    { label: "Academic", href: "#academic" },
];

export default function NavBar() {
    const [open, setOpen] = useState(false);

    // lock body scroll when mobile menu is open
    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    return (
        <header className="iia-nav">
            <div className="iia-nav-inner">
                {/* Logo */}
                <a href="#home" className="iia-logo" onClick={() => setOpen(false)}>
                    <img
                        src={iiaLogo}
                        alt="IIA Logo"
                        className="iia-logo-img"
                    />
                    <span className="iia-logo-copy">
                        <span className="iia-logo-title">
                            International Institute
                            <br />
                            of <span className="iia-logo-highlight">Automate</span>
                        </span>
                        <span className="iia-logo-sub">
                            Building Industry-Ready Engineers
                        </span>
                    </span>
                </a>

                {/* Desktop nav links */}
                <nav className="iia-links" aria-label="Primary">
                    {NAV_LINKS.map((link, i) => (
                        <a
                            key={link.label}
                            href={link.href}
                            className={`iia-link${i === 0 ? " iia-link--active" : ""}`}
                        >
                            {link.label}
                        </a>
                    ))}
                </nav>

                {/* Desktop actions */}
                <div className="iia-actions">
                    <a
                        href="https://youtube.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="iia-youtube"
                    >
                        <span className="iia-youtube-icon" aria-hidden="true">
                            ▶
                        </span>
                        IIA YouTube
                    </a>
                    <a href="#enquire" className="iia-enquire">
                        Enquire Now
                    </a>
                </div>

                {/* Mobile hamburger */}
                <button
                    className={`iia-burger${open ? " iia-burger--open" : ""}`}
                    aria-label={open ? "Close menu" : "Open menu"}
                    aria-expanded={open}
                    onClick={() => setOpen((v) => !v)}
                >
                    <span />
                    <span />
                    <span />
                </button>
            </div>

            {/* Mobile menu panel */}
            <div className={`iia-mobile${open ? " iia-mobile--open" : ""}`}>
                <nav className="iia-mobile-links" aria-label="Primary mobile">
                    {NAV_LINKS.map((link) => (
                        <a
                            key={link.label}
                            href={link.href}
                            className="iia-mobile-link"
                            onClick={() => setOpen(false)}
                        >
                            {link.label}
                        </a>
                    ))}
                </nav>

                <div className="iia-mobile-actions">
                    <a
                        href="https://youtube.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="iia-youtube iia-youtube--mobile"
                    >
                        <span className="iia-youtube-icon" aria-hidden="true">
                            ▶
                        </span>
                        IIA YouTube
                    </a>
                    <a
                        href="#enquire"
                        className="iia-enquire iia-enquire--mobile"
                        onClick={() => setOpen(false)}
                    >
                        Enquire Now
                    </a>
                </div>
            </div>
        </header>
    );
}